import React from "react";
import {HallBaseConfig} from "../../../reducers/hallsList.reducer";
import HallCardComponent from "../HallCard/HallCard.component";
import HallRowComponent from "../HallRow/HallRow.component";
import {HallsListFilters} from "../../../reducers/hallsListFilters.reducer";
import {HallListViews} from "../../../types/filters";
import {AuthorizationServiceTypes} from "../../../../../utils/Authorization/authorizationTypes";
import {checkAuthorization, checkPermission} from "./../../../../../utils/Authorization/authorization";
import {ActionCreator} from "../../../../../actions/actions";

export interface HallsListProps {
    hallsList: HallBaseConfig[];
    filters: HallsListFilters;
    activateHall: ActionCreator;
}

export const HallsList = (props: HallsListProps) => {
    const hasLicensesAccess = checkAuthorization({
        service: AuthorizationServiceTypes.LICENSES
    });

    return (
        <div className="row">
            <div className="cards-container">
                {!props.hallsList.length && (
                    <div className="empty-halls">No Halls records to display. Please select different
                        values to try again.</div>
                )}
                {props.hallsList.length > 0 &&
                    props.filters.viewMode == HallListViews.GRID &&
                    props.hallsList.map(
                        hall =>
                            <HallCardComponent
                                toggleActiveAction={
                                    props.activateHall
                                }
                                hallInfo={hall}
                                key={hall.id}
                            />
                    )}
                {props.hallsList.length > 0 && props.filters.viewMode == HallListViews.LIST && (
                    <div className="hall-list-view">
                        <table>
                            <thead>
                            <tr>
                                <td>Status</td>
                                <td>Hall Name</td>
                                <td className="hidden-md">Location</td>
                                <td className="hidden-lg">Created on</td>
                                <td className="hidden-xs">Servers</td>
                                {hasLicensesAccess && (
                                    <td className="hidden-sm">
                                        Licenses Status
                                    </td>
                                )}
                                {checkPermission("spec_history") && (
                                    <td className="hidden-sm">
                                        Certified Status
                                    </td>
                                )}
                                <td/>
                            </tr>
                            </thead>
                            <tbody>
                            {props.hallsList.map(hall => (
                                <HallRowComponent
                                    toggleActiveAction={props.activateHall}
                                    hallInfo={hall}
                                    key={hall.id}
                                />
                            ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};
